import React, { FC, memo } from "react";
import { IconType } from "enums/Icon";
import { Visible } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Icon from "../../components/Icon/Icon";
import ThemeModeToggle from "../../components/ThemeModeToggle/ThemeModeToggle";
import { authSelectAllowExtendedTools } from "../../reduxFolder/selectors/globalSelectors";
import BasicHeader from "./components/BasicHeader";
import {
  BasicHeaderWrapper,
  Header,
  HeaderActions,
  HeaderWrapper,
  MobileMenuButton,
} from "./HeaderContainer.styles";

interface HeaderContainersProps {
  toggleMenu: () => void;
  isMenuOpen?: boolean;
  withMenu?: boolean;
  allowExtendedTools?: boolean;
}

const HeaderContainer: FC<HeaderContainersProps> = ({
  toggleMenu,
  withMenu,
  isMenuOpen,
  allowExtendedTools = false,
}) => {
  const { t } = useTranslation("common");

  return (
  <HeaderWrapper>
    <Header $withMenu={withMenu}>
      {withMenu && (
        <Visible sm xs>
          <MobileMenuButton
            aria-label={t("common.openMenu")}
            data-testid="open-menu"
            onClick={toggleMenu}
          >
            <Icon type={IconType.MenuBurger} />
          </MobileMenuButton>
        </Visible>
      )}
      <BasicHeaderWrapper hidden={isMenuOpen}>
        <BasicHeader />
      </BasicHeaderWrapper>
      {allowExtendedTools && !isMenuOpen && (
        <HeaderActions>
          <ThemeModeToggle />
        </HeaderActions>
      )}
    </Header>
  </HeaderWrapper>
  );
};

const withConnect = connect(
  createStructuredSelector({
    allowExtendedTools: authSelectAllowExtendedTools,
  }),
);

export default withConnect(memo(HeaderContainer));
